import { useEffect, useId, useRef } from "react";
import { useEmbeddedHost } from "../embedded-host-provider";
import type { UnsavedWorkReason } from "../protocol";

/**
 * 登记未保存内容（设计 §5.5.4）。
 *
 * 跨源 iframe 的 `beforeunload` 拦不住父页面销毁自己，所以这里只做**协商**：
 * 上报 `navigation:block`，由宿主自己弹确认框。宿主没实现该协议时草稿会丢，
 * 属已知取舍——但丢弃必须是干净的，不留半截上传或孤儿附件。
 */
export function useUnsavedWork(hasUnsavedWork: boolean, reason: UnsavedWorkReason = "draft"): void {
  const { setUnsavedWork, clearUnsavedWork } = useEmbeddedHost();
  const key = useId();
  const reasonRef = useRef(reason);
  reasonRef.current = reason;

  useEffect(() => {
    if (hasUnsavedWork) {
      setUnsavedWork(key, reasonRef.current);
    } else {
      clearUnsavedWork(key);
    }

    return () => {
      clearUnsavedWork(key);
    };
  }, [clearUnsavedWork, hasUnsavedWork, key, setUnsavedWork]);
}
